import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { StoreListForPickup } from "components/store/StoreList";
import { useDispatch, useSelector } from "react-redux";
import { BrandAction } from "store/actions";
import ChangePickupStoreModalContainer from "./ChangePickupStoreModalContainer";
import { PreOrderingSlotWidget } from "components/Pre-ordering";
import { NotPersistAction } from "store/actions";
import SelectedLocation from "./SelectedLocation";
import SlideInLayout from "components/layouts/SlideInLayout";

function PickupChangeStoreTo({ lang }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { stores } = useSelector((state) => state?.brand);
  const { selectedStore } = useSelector((state) => state?.store);
  const { orderTiming } = useSelector((state) => state?.orderTimingReducer);

  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);
  const { pickupStoreModal } = useSelector((state) => state?.NotPersist);
  const [isContainerModalopen, setContainerModalopen] = useState(false);
  const [isPreOrderingSlotWidget, setPreOrderingSlotWidget] = useState(false);
  //change store
  const handleChnagePickupStore = () => {
    dispatch(BrandAction.getBrandStores(brandInfo?.brand._id));
    dispatch(NotPersistAction.togglePickupStoreModal(true));
  };

  return (
    <>
      <SelectedLocation
        storeName={selectedStore?.baseLanguage?.name}
        orderTiming={orderTiming}
        title={t("Pickup from")}
        onClick={()=>setContainerModalopen(true)}
      />
      <SlideInLayout
        shouldCloseOnEsc="No"
        shouldCloseOnOverlayClick="No"
        hideOutsideCloseButton={true}
        open={pickupStoreModal}
        handleClose={()=>NotPersistAction.togglePickupStoreModal(false)}
        container={{
          className: `py-2 h-5 min-h-70p `,
        }}
      >
        <StoreListForPickup
          stores={stores}
          header={false}
          headerLabel=""
          styleClasses="h-full"
        />
      </SlideInLayout>

      <ChangePickupStoreModalContainer
        isContainerModalopen={isContainerModalopen}
        setContainerModalopen={setContainerModalopen}
        handleChangeOrderStore={handleChnagePickupStore}
        setPreOrderingSlotWidget={setPreOrderingSlotWidget}
        preORderSlots={selectedStore?.availablePreOrderSlotsForPickup}
        isPreORderEnabled={selectedStore?.isPreOrderEnabledForPickup}
      />

      <PreOrderingSlotWidget
        selectedStore={selectedStore}
        isPreOrderingSlotWidget={isPreOrderingSlotWidget}
        setPreOrderingSlotWidget={setPreOrderingSlotWidget}
      />
    </>
  );
}

export default PickupChangeStoreTo;
